import moment from "moment";
import "moment-timezone";
import React from "react";
import { formats } from "../../../variables/variables";

const DAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

const slotsFor = (week, day) => {
  const times = (week && week[day.toLowerCase()]) || [];
  return times.map((time) => `${time.from}-${time.to}`).join(", ");
};

const MultiWeekPatterns = ({ patterns, remove, setAddMode, style = {} }) => (
  <div style={{ ...{ minWidth: 800 }, ...style }}>
    <h4>
      Multi-Week Patterns{" "}
      <small className="btn btn-link" onClick={() => setAddMode(true)}>
        add
      </small>
    </h4>
    {patterns.length === 0 ? (
      <p>
        <span style={{ color: "#888" }}>
          none - Regular Hours above apply every week
        </span>
      </p>
    ) : (
      <table className="table table-condensed table-zebra">
        <thead>
          <tr>
            <th style={{ width: 260 }}>Starting</th>
            <th style={{ width: 120 }}>Runs For</th>
            <th style={{ minWidth: 340 }}>Work Hours</th>
            <th style={{ minWidth: 150 }}>Description</th>
          </tr>
        </thead>
        <tbody>
          {patterns.map((pattern, index) => {
            const weeks = pattern.weeks_availability || [];
            return (
              <tr key={pattern.id}>
                <td>
                  <span
                    className="text-danger"
                    style={{ cursor: "pointer", marginRight: 10 }}
                    onClick={() => remove(index)}
                  >
                    <i className="far fa-times-circle"></i>
                  </span>
                  <span>
                    {moment(pattern.starts_on, formats.consistentDateFormat).format(
                      formats.shortDateYear
                    )}
                  </span>
                </td>
                <td>
                  {pattern.repeat_for_weeks
                    ? `${pattern.repeat_for_weeks} week${pattern.repeat_for_weeks === 1 ? "" : "s"}`
                    : "ongoing"}
                </td>
                <td>
                  {weeks.map((week, weekIndex) => (
                    <div key={weekIndex} style={{ marginBottom: weeks.length > 1 ? 6 : 0 }}>
                      {weeks.length > 1 && (
                        <strong style={{ marginRight: 8 }}>Week {weekIndex + 1}</strong>
                      )}
                      {DAYS.filter((day) => slotsFor(week, day)).length === 0 ? (
                        <span style={{ color: "#888" }}>not working</span>
                      ) : (
                        DAYS.filter((day) => slotsFor(week, day)).map((day) => (
                          <span style={{ marginRight: 12 }} key={day}>
                            {day.substring(0, 3)} {slotsFor(week, day)}
                          </span>
                        ))
                      )}
                    </div>
                  ))}
                </td>
                <td>{pattern.description || "-"}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    )}
  </div>
);

export default MultiWeekPatterns;
